import React from 'react';
import { useDispatch } from 'react-redux';
import DTCopyTextSendMacroView from '../DTCopyTextSendMacroView';
import { processRbiIssueLoyaltyPoints } from '../../../../../actions/tools/RBIActions';
import { withConfirmation } from '../../../DTConfirmationView/withConfirmation';

const DTRBIIssueLoyaltyPointsThenSendMacroNode = () => {
  const dispatch = useDispatch();

  const handleNextButtonClick = async () => await dispatch(processRbiIssueLoyaltyPoints());

  return (
    <DTCopyTextSendMacroView
      buttonText={'ISSUE POINTS'}
      onNextButtonClick={handleNextButtonClick}
      hideCopyText={true}
      popupConfirmationText={'You are about to issue loyalty points and copy the response to the text box'}
      customErrorMessage={'Loyalty points issuing request has failed. Please try again later.'}
    />
  );
};

export default withConfirmation(DTRBIIssueLoyaltyPointsThenSendMacroNode);
